export const STRING_BOOLEAN = {
  TRUE: "true",
  FALSE: "false",
} as const;

export type StringBoolean = (typeof STRING_BOOLEAN)[keyof typeof STRING_BOOLEAN];
